import {Button, ButtonProps} from "antd";

export function JbButtonComponent(props: ButtonProps) {
  return (
    <Button
      shape={'round'}
      {...props}
    />
  )
}